import { all, takeLatest } from "redux-saga/effects";
import { Types as PermissionsTypes } from "../ducks/permissions";
import { getPermissions, getFullComunicados } from "./permissions";

import { Types as BancosTypes } from "../ducks/bancos";
import { Types as OperacoesTypes } from "../ducks/operacoes";
import { Types as OrigemVendasTypes } from "../ducks/origemVendas";
import { Types as PromotorasTypes } from "../ducks/promotoras";
import { Types as ProdutosTypes } from "../ducks/produtos";
import { Types as CargosTypes } from "../ducks/cargos";
import { Types as TiposUsuariosTypes } from "../ducks/tiposUsuarios";
import { Types as StatusPropostaTypes } from "../ducks/statusProposta";
import { Types as TabelasConveniosTypes } from "../ducks/tabelasConvenios";
import { Types as LojasTypes } from "../ducks/lojas";
import { Types as UsuariosTypes } from "../ducks/usuarios";
import { Types as RegioesTypes } from "../ducks/regioes";
import { Types as GruposAcessosTypes } from "../ducks/gruposAcessos";
import { Types as FeriadosTypes } from "../ducks/feriados";
import { Types as ClientesTypes } from "../ducks/clientes";
import { Types as PropostasTypes } from "../ducks/propostas";
import { Types as ModalCustomerTypes } from "../ducks/modalCustomer";
import { Types as DesempenhoTypes } from "../ducks/desempenho";
import { Types as RankingsTypes } from "../ducks/rankings";
import { Types as PropostasAlertasTypes } from "../ducks/propostasAlertas";
import { Types as BorderosTypes } from "../ducks/borderos";
import { Types as ExtratoPagoTypes } from "../ducks/extratoPago";
import { Types as GerarRepassesTypes } from "../ducks/gerarRepasses";
import { Types as EmpresaTypes } from "../ducks/empresa";
import { Types as MetasTypes } from "../ducks/metas";
import { Types as RelatorioMetasTypes } from "../ducks/relatorioMetas";
import { Types as ComunicadosTypes } from "../ducks/comunicados";
import { Types as StatusAtendimentoTypes } from "../ducks/statusAtendimento";
import { Types as FormasAtendimentoTypes } from "../ducks/formasAtendimento";
import { Types as BuscaClienteTypes } from "../ducks/buscaCliente";
import { Types as AtendimentoTypes } from "../ducks/atendimento";
import { Types as RelatorioAtendimentoTypes } from "../ducks/relatorioAtendimento";
import { Types as CampanhasTypes } from "../ducks/campanhas";
import { Types as ConsignadoInssTypes } from "../ducks/consignadoInss";
import { Types as DadosCadastraisTypes } from "../ducks/dadosCadastrais";
import { Types as AgendamentosTypes } from "../ducks/agendamentos";
import { Types as OrganogramaTypes } from "../ducks/organograma";
import { Types as TiposCompromissosTypes } from "../ducks/tiposCompromissos";
import { Types as CalendarioPesquisadorTypes } from "../ducks/calendarioPesquisador";
import { Types as CategoriasPagamentosTypes } from "../ducks/categoriasPagamentos";
import { Types as CategoriasRecebimentosTypes } from "../ducks/categoriasRecebimentos";
import { Types as MetodosPagamentosTypes } from "../ducks/metodosPagamentos";
import { Types as LancamentosTypes } from "../ducks/lancamentos";
import { Types as GruposRepassesTypes } from "../ducks/gruposRepasses";
import { Types as ExtratoTypes } from "../ducks/extrato";
import { Types as ContasBancariasTypes } from "../ducks/contasBancarias";
import { Types as CoeficientesTypes } from "../ducks/coeficientes";
import { Types as FiltrosValoresDiariosTypes } from "../ducks/filtrosValoresDiarios";
import { Types as FiltrosCalendarioUsoPesquisadorTypes } from "../ducks/filtrosCalendarioUsoPesquisador";
import { Types as ImportacoesTypes } from "../ducks/importacoes";
import { Types as CategoriasBonusDescontoTypes } from "../ducks/categoriasBonusDesconto";
import { Types as BonusDescontoTypes } from "../ducks/bonusDesconto";

import {
  getListBancos,
  getBanco,
  editBanco,
  addBanco,
  deleteBanco,
  searchBanco,
  getListBancosSelects,
  deleteAllBanco,
} from "./bancos";

import { getValues, getPropostasDiarios } from "./filtrosValoresDiarios";

import { getValuesPesquisador } from "./filtrosCalendarioUsoPesquisador";

import {
  getListOperacoes,
  getOperacoes,
  editOperacoes,
  addOperacoes,
  deleteOperacoes,
  searchOperacoes,
  getListOperacoesSelects,
  deleteAllOperacoes,
} from "./operacoes";

import {
  getListOrigemVendas,
  getOrigemVendas,
  editOrigemVendas,
  addOrigemVendas,
  deleteOrigemVendas,
  searchOrigemVendas,
  deleteAllOrigemVendas,
} from "./origemVendas";

import {
  getListPromotoras,
  getPromotoras,
  editPromotoras,
  addPromotoras,
  deletePromotoras,
  searchPromotoras,
  getListPromotorasSelects,
  deleteAllPromotoras,
} from "./promotoras";

import {
  getListProdutos,
  getProdutos,
  editProdutos,
  addProdutos,
  deleteProdutos,
  searchProdutos,
  getListProdutosSelects,
  deleteAllProdutos,
} from "./produtos";

import {
  getListCargos,
  getCargos,
  editCargos,
  addCargos,
  deleteCargos,
  searchCargos,
  deleteAllCargos,
} from "./cargos";

import {
  getListTiposUsuarios,
  getTiposUsuarios,
  editTiposUsuarios,
  addTiposUsuarios,
  deleteTiposUsuarios,
  searchTiposUsuarios,
  deleteAllTiposUsuarios,
} from "./tiposUsuarios";

import {
  getListStatusProposta,
  getStatusProposta,
  editStatusProposta,
  addStatusProposta,
  deleteStatusProposta,
  searchStatusProposta,
  deleteAllStatusProposta,
} from "./statusProposta";

import {
  getListTabelasConvenios,
  getTabelasConvenios,
  editTabelasConvenios,
  addTabelasConvenios,
  replicaTabelasConvenios,
  deleteTabelasConvenios,
  searchTabelasConvenios,
  deleteAllTabelasConvenios,
  encerraTabelasConvenios,
} from "./tabelasConvenios";

import {
  getListLojas,
  getLojas,
  editLojas,
  addLojas,
  deleteLojas,
  searchLojas,
  getListLojasSelects,
  deleteAllLojas,
} from "./lojas";

import {
  getListUsuarios,
  getUsuarios,
  editUsuarios,
  addUsuarios,
  deleteUsuarios,
  searchUsuarios,
  getListUsuariosSelects,
  deleteAllUsuarios,
  getUsuarioLocalWorking,
  addUsuarioLocalWorking,
  editUsuarioLocalWorking,
  deleteUsuarioLocalWorking,
} from "./usuarios";

import {
  getListRegioes,
  getRegioes,
  editRegioes,
  addRegioes,
  deleteRegioes,
  searchRegioes,
  getListRegioesSelects,
  deleteAllRegioes,
} from "./regioes";

import {
  getListGruposAcessos,
  getGruposAcessos,
  editGruposAcessos,
  addGruposAcessos,
  deleteGruposAcessos,
  searchGruposAcessos,
  getListGruposAcessosSelects,
  deleteAllGruposAcessos,
} from "./gruposAcessos";

import {
  getListFeriados,
  getFeriados,
  editFeriados,
  addFeriados,
  deleteFeriados,
  searchFeriados,
  getListFeriadosSelects,
  deleteAllFeriados,
} from "./feriados";

import {
  getListClientes,
  getClientes,
  getClientesDocs,
  editClientes,
  addClientes,
  deleteClientes,
  searchClientes,
  getListClientesSelects,
  deleteAllClientes,
} from "./clientes";

import {
  getListPropostas,
  getTotalsPropostas,
  getPropostas,
  getPropostaHistory,
  getPropostasRelatorio,
  getDocsPropostas,
  editPropostas,
  addPropostas,
  deletePropostas,
  searchPropostas,
  getListPropostasSelects,
  print,
  checkColumn,
  deleteAllPropostas,
  ratePropostas,
} from "./propostas";

import {
  deletePropostasAlertas,
  getListPropostasAlertas,
  getPropostasAlertas,
  getPropostasAlertasCount,
  printAlertas,
} from "./propostasAlertas";

import {
  getListBorderos,
  getBorderos,
  editBorderos,
  addBorderos,
  deleteBorderos,
  searchBorderos,
  getListBorderosSelects,
  printBordero,
  deleteAllBorderos,
  getDocsPropostasBordero,
} from "./borderos";

import {
  getListExtratoPago,
  getExtratoPago,
  deleteExtratoPago,
} from "./extratoPago";

import { getListGerarRepasses, getGerarRepasses } from "./gerarRepasses";

import { openCustomer } from "./modalCustomer";

import { getListDesempenho } from "./desempenho";

import { getListRankings } from "./rankings";

import { getListMetasRelatorio } from "./relatorioMetas";

import { getEmpresa, editEmpresa } from "./empresa";

import {
  getListMetas,
  getMetas,
  editMetas,
  addMetas,
  addMetasMetas,
  deleteMetas,
  searchMetas,
  getListMetasSelects,
} from "./metas";

import {
  getListComunicados,
  getComunicados,
  editComunicados,
  addComunicados,
  deleteComunicados,
  searchComunicados,
  getListComunicadosSelects,
  deleteAllComunicados,
} from "./comunicados";

import {
  getListStatusAtendimento,
  getStatusAtendimento,
  editStatusAtendimento,
  addStatusAtendimento,
  deleteStatusAtendimento,
  searchStatusAtendimento,
  getListStatusAtendimentoSelects,
  deleteAllStatusAtendimento,
} from "./statusAtendimento";

import {
  getListFormasAtendimento,
  getFormasAtendimento,
  editFormasAtendimento,
  addFormasAtendimento,
  deleteFormasAtendimento,
  searchFormasAtendimento,
  getListFormasAtendimentoSelects,
  deleteAllFormasAtendimento,
} from "./formasAtendimento";

import { buscaClienteAction, sorteiaCliente } from "./buscaCliente";

import {
  getAtendimento,
  iniciaAtendimento,
  finalizaAtendimento,
} from "./atendimento";

import { getListRelatorioAtendimento } from "./relatorioAtendimento";

import {
  getListCampanhas,
  getCampanhas,
  editCampanhas,
  addCampanhas,
  deleteCampanhas,
  searchCampanhas,
  deleteAllCampanhas,
} from "./campanhas";

import { searchCPF, searchNB } from "./consignadoInss";

import {
  searchDados,
  searchDadosTab,
  searchDadosCnpjTab,
  searchDadosRelacionadasTab,
} from "./dadosCadastrais";

import {
  getAgendamentos,
  addAgendamentos,
  getAgendamento,
  editAgendamentos,
  excluirAgendamentos,
} from "./agendamentos";

import { getOrganograma } from "./organograma";

import {
  getListTiposCompromissos,
  getTiposCompromissos,
  editTiposCompromissos,
  addTiposCompromissos,
  deleteTiposCompromissos,
  searchTiposCompromissos,
  getListTiposCompromissosSelects,
} from "./tiposCompromissos";

import { getCalendarioPesquisador } from "./calendarioPesquisador";

import {
  getListCategoriasPagamentos,
  getCategoriasPagamentos,
  editCategoriasPagamentos,
  addCategoriasPagamentos,
  deleteCategoriasPagamentos,
  searchCategoriasPagamentos,
  getListCategoriasPagamentosSelects,
  deleteAllCategoriasPagamentos,
} from "./categoriasPagamentos";

import {
  getListCategoriasRecebimentos,
  getCategoriasRecebimentos,
  editCategoriasRecebimentos,
  addCategoriasRecebimentos,
  deleteCategoriasRecebimentos,
  searchCategoriasRecebimentos,
  getListCategoriasRecebimentosSelects,
  deleteAllCategoriasRecebimentos,
} from "./categoriasRecebimentos";

import {
  getListMetodosPagamentos,
  getMetodosPagamentos,
  editMetodosPagamentos,
  addMetodosPagamentos,
  deleteMetodosPagamentos,
  searchMetodosPagamentos,
  getListMetodosPagamentosSelects,
  deleteAllMetodosPagamentos,
} from "./metodosPagamentos";

import {
  getListLancamentos,
  getLancamentos,
  editLancamentos,
  getExport,
  addLancamentos,
  deleteLancamentos,
  searchLancamentos,
  getListLancamentosSelects,
  deleteAllLancamentos,
  deleteLancamentosParcela,
} from "./lancamentos";

import {
  getListGruposRepasses,
  getGruposRepasses,
  editGruposRepasses,
  addGruposRepasses,
  deleteGruposRepasses,
  searchGruposRepasses,
  getListGruposRepassesSelects,
  deleteAllGruposRepasses,
} from "./gruposRepasses";

import { getListExtrato } from "./extrato";

import {
  getListContasBancarias,
  getContasBancarias,
  editContasBancarias,
  addContasBancarias,
  deleteContasBancarias,
  searchContasBancarias,
  getListContasBancariasSelects,
  deleteAllContasBancarias,
} from "./contasBancarias";

import {
  getListCoeficientes,
  getCoeficientes,
  editCoeficientes,
  addCoeficientes,
  deleteCoeficientes,
  searchCoeficientes,
  getListCoeficientesSelects,
  deleteAllCoeficientes,
} from "./coeficientes";

import {
  getListImportacoes,
  getImportacoes,
  editImportacoes,
  addImportacoes,
  deleteImportacoes,
  searchImportacoes,
  getListImportacoesSelects,
  deleteAllImportacoes,
} from "./importacoes";

import {
  getListCategoriasBonusDesconto,
  getCategoriasBonusDesconto,
  editCategoriasBonusDesconto,
  addCategoriasBonusDesconto,
  deleteCategoriasBonusDesconto,
  searchCategoriasBonusDesconto,
  getListCategoriasBonusDescontoSelects,
  deleteAllCategoriasBonusDesconto,
} from "./categoriasBonusDesconto";

import {
  getListBonusDesconto,
  getBonusDesconto,
  editBonusDesconto,
  addBonusDesconto,
  deleteBonusDesconto,
  searchBonusDesconto,
  getListBonusDescontoSelects,
  deleteAllBonusDesconto,
  deleteBonusDescontoParcela,
} from "./bonusDesconto";

export default function* rootSaga() {
  yield all([
    takeLatest(ModalCustomerTypes.OPEN_CUSTOMER, openCustomer),
    takeLatest(PermissionsTypes.GET_PERMISSIONS, getPermissions),
    takeLatest(BancosTypes.GET_LIST_BANCOS, getListBancos),
    takeLatest(BancosTypes.GET_BANCO, getBanco),
    takeLatest(BancosTypes.EDIT_BANCO, editBanco),
    takeLatest(BancosTypes.ADD_BANCO, addBanco),
    takeLatest(BancosTypes.DELETE_BANCO, deleteBanco),
    takeLatest(BancosTypes.SEARCH_BANCO, searchBanco),
    takeLatest(BancosTypes.GET_LIST_BANCOS_SELECTS, getListBancosSelects),
    takeLatest(BancosTypes.DELETE_ALL_BANCO, deleteAllBanco),
    takeLatest(OperacoesTypes.GET_LIST_OPERACOES, getListOperacoes),
    takeLatest(OperacoesTypes.GET_OPERACOES, getOperacoes),
    takeLatest(OperacoesTypes.EDIT_OPERACOES, editOperacoes),
    takeLatest(OperacoesTypes.ADD_OPERACOES, addOperacoes),
    takeLatest(OperacoesTypes.DELETE_OPERACOES, deleteOperacoes),
    takeLatest(OperacoesTypes.SEARCH_OPERACOES, searchOperacoes),
    takeLatest(
      OperacoesTypes.GET_LIST_OPERACOES_SELECTS,
      getListOperacoesSelects
    ),
    takeLatest(OperacoesTypes.DELETE_ALL_OPERACOES, deleteAllOperacoes),
    takeLatest(OrigemVendasTypes.GET_LIST_ORIGEM_VENDAS, getListOrigemVendas),
    takeLatest(OrigemVendasTypes.GET_ORIGEM_VENDAS, getOrigemVendas),
    takeLatest(OrigemVendasTypes.EDIT_ORIGEM_VENDAS, editOrigemVendas),
    takeLatest(OrigemVendasTypes.ADD_ORIGEM_VENDAS, addOrigemVendas),
    takeLatest(OrigemVendasTypes.DELETE_ORIGEM_VENDAS, deleteOrigemVendas),
    takeLatest(OrigemVendasTypes.SEARCH_ORIGEM_VENDAS, searchOrigemVendas),
    takeLatest(
      OrigemVendasTypes.DELETE_ALL_ORIGEM_VENDAS,
      deleteAllOrigemVendas
    ),
    takeLatest(PromotorasTypes.GET_LIST_PROMOTORAS, getListPromotoras),
    takeLatest(PromotorasTypes.GET_PROMOTORAS, getPromotoras),
    takeLatest(PromotorasTypes.EDIT_PROMOTORAS, editPromotoras),
    takeLatest(PromotorasTypes.ADD_PROMOTORAS, addPromotoras),
    takeLatest(PromotorasTypes.DELETE_PROMOTORAS, deletePromotoras),
    takeLatest(PromotorasTypes.SEARCH_PROMOTORAS, searchPromotoras),
    takeLatest(
      PromotorasTypes.GET_LIST_PROMOTORAS_SELECTS,
      getListPromotorasSelects
    ),
    takeLatest(PromotorasTypes.DELETE_ALL_PROMOTORAS, deleteAllPromotoras),
    takeLatest(ProdutosTypes.GET_LIST_PRODUTOS, getListProdutos),
    takeLatest(ProdutosTypes.GET_PRODUTOS, getProdutos),
    takeLatest(ProdutosTypes.EDIT_PRODUTOS, editProdutos),
    takeLatest(ProdutosTypes.ADD_PRODUTOS, addProdutos),
    takeLatest(ProdutosTypes.DELETE_PRODUTOS, deleteProdutos),
    takeLatest(ProdutosTypes.SEARCH_PRODUTOS, searchProdutos),
    takeLatest(ProdutosTypes.GET_LIST_PRODUTOS_SELECTS, getListProdutosSelects),
    takeLatest(ProdutosTypes.DELETE_ALL_PRODUTOS, deleteAllProdutos),
    takeLatest(CargosTypes.GET_LIST_CARGOS, getListCargos),
    takeLatest(CargosTypes.GET_CARGOS, getCargos),
    takeLatest(CargosTypes.EDIT_CARGOS, editCargos),
    takeLatest(CargosTypes.ADD_CARGOS, addCargos),
    takeLatest(CargosTypes.DELETE_CARGOS, deleteCargos),
    takeLatest(CargosTypes.SEARCH_CARGOS, searchCargos),
    takeLatest(CargosTypes.DELETE_ALL_CARGOS, deleteAllCargos),
    takeLatest(
      TiposUsuariosTypes.GET_LIST_TIPOS_USUARIOS,
      getListTiposUsuarios
    ),
    takeLatest(TiposUsuariosTypes.GET_TIPOS_USUARIOS, getTiposUsuarios),
    takeLatest(TiposUsuariosTypes.EDIT_TIPOS_USUARIOS, editTiposUsuarios),
    takeLatest(TiposUsuariosTypes.ADD_TIPOS_USUARIOS, addTiposUsuarios),
    takeLatest(TiposUsuariosTypes.DELETE_TIPOS_USUARIOS, deleteTiposUsuarios),
    takeLatest(TiposUsuariosTypes.SEARCH_TIPOS_USUARIOS, searchTiposUsuarios),
    takeLatest(
      TiposUsuariosTypes.DELETE_ALL_TIPOS_USUARIOS,
      deleteAllTiposUsuarios
    ),
    takeLatest(
      StatusPropostaTypes.GET_LIST_STATUS_PROPOSTA,
      getListStatusProposta
    ),
    takeLatest(StatusPropostaTypes.GET_STATUS_PROPOSTA, getStatusProposta),
    takeLatest(StatusPropostaTypes.EDIT_STATUS_PROPOSTA, editStatusProposta),
    takeLatest(StatusPropostaTypes.ADD_STATUS_PROPOSTA, addStatusProposta),
    takeLatest(
      StatusPropostaTypes.DELETE_STATUS_PROPOSTA,
      deleteStatusProposta
    ),
    takeLatest(
      StatusPropostaTypes.SEARCH_STATUS_PROPOSTA,
      searchStatusProposta
    ),
    takeLatest(
      StatusPropostaTypes.DELETE_ALL_STATUS_PROPOSTA,
      deleteAllStatusProposta
    ),
    takeLatest(
      TabelasConveniosTypes.GET_LIST_TABELAS_CONVENIOS,
      getListTabelasConvenios
    ),
    takeLatest(
      TabelasConveniosTypes.GET_TABELAS_CONVENIOS,
      getTabelasConvenios
    ),
    takeLatest(
      TabelasConveniosTypes.EDIT_TABELAS_CONVENIOS,
      editTabelasConvenios
    ),
    takeLatest(
      TabelasConveniosTypes.ADD_TABELAS_CONVENIOS,
      addTabelasConvenios
    ),
    takeLatest(
      TabelasConveniosTypes.REPLICA_TABELAS_CONVENIOS,
      replicaTabelasConvenios
    ),
    takeLatest(
      TabelasConveniosTypes.DELETE_TABELAS_CONVENIOS,
      deleteTabelasConvenios
    ),
    takeLatest(
      TabelasConveniosTypes.SEARCH_TABELAS_CONVENIOS,
      searchTabelasConvenios
    ),
    takeLatest(
      TabelasConveniosTypes.DELETE_ALL_TABELAS_CONVENIOS,
      deleteAllTabelasConvenios
    ),
    takeLatest(
      TabelasConveniosTypes.ENCERRA_TABELAS_CONVENIOS,
      encerraTabelasConvenios
    ),
    takeLatest(LojasTypes.GET_LIST_LOJAS, getListLojas),
    takeLatest(LojasTypes.GET_LOJAS, getLojas),
    takeLatest(LojasTypes.EDIT_LOJAS, editLojas),
    takeLatest(LojasTypes.ADD_LOJAS, addLojas),
    takeLatest(LojasTypes.DELETE_LOJAS, deleteLojas),
    takeLatest(LojasTypes.SEARCH_LOJAS, searchLojas),
    takeLatest(LojasTypes.GET_LIST_LOJAS_SELECTS, getListLojasSelects),
    takeLatest(LojasTypes.DELETE_ALL_LOJAS, deleteAllLojas),
    takeLatest(UsuariosTypes.GET_LIST_USUARIOS, getListUsuarios),
    takeLatest(UsuariosTypes.GET_USUARIOS, getUsuarios),
    takeLatest(UsuariosTypes.GET_USUARIO_LOCAL_WORKING, getUsuarioLocalWorking),
    takeLatest(UsuariosTypes.ADD_USUARIO_LOCAL_WORKING, addUsuarioLocalWorking),
    takeLatest(
      UsuariosTypes.EDIT_USUARIO_LOCAL_WORKING,
      editUsuarioLocalWorking
    ),
    takeLatest(
      UsuariosTypes.DELETE_USUARIO_LOCAL_WORKING,
      deleteUsuarioLocalWorking
    ),
    takeLatest(UsuariosTypes.EDIT_USUARIOS, editUsuarios),
    takeLatest(UsuariosTypes.ADD_USUARIOS, addUsuarios),
    takeLatest(UsuariosTypes.DELETE_USUARIOS, deleteUsuarios),
    takeLatest(UsuariosTypes.SEARCH_USUARIOS, searchUsuarios),
    takeLatest(UsuariosTypes.GET_LIST_USUARIOS_SELECTS, getListUsuariosSelects),
    takeLatest(UsuariosTypes.DELETE_ALL_USUARIOS, deleteAllUsuarios),
    takeLatest(RegioesTypes.GET_LIST_REGIOES, getListRegioes),
    takeLatest(RegioesTypes.GET_REGIOES, getRegioes),
    takeLatest(RegioesTypes.EDIT_REGIOES, editRegioes),
    takeLatest(RegioesTypes.ADD_REGIOES, addRegioes),
    takeLatest(RegioesTypes.DELETE_REGIOES, deleteRegioes),
    takeLatest(RegioesTypes.SEARCH_REGIOES, searchRegioes),
    takeLatest(RegioesTypes.GET_LIST_REGIOES_SELECTS, getListRegioesSelects),
    takeLatest(RegioesTypes.DELETE_ALL_REGIOES, deleteAllRegioes),
    takeLatest(
      GruposAcessosTypes.GET_LIST_GRUPOS_ACESSOS,
      getListGruposAcessos
    ),
    takeLatest(GruposAcessosTypes.GET_GRUPOS_ACESSOS, getGruposAcessos),
    takeLatest(GruposAcessosTypes.EDIT_GRUPOS_ACESSOS, editGruposAcessos),
    takeLatest(GruposAcessosTypes.ADD_GRUPOS_ACESSOS, addGruposAcessos),
    takeLatest(GruposAcessosTypes.DELETE_GRUPOS_ACESSOS, deleteGruposAcessos),
    takeLatest(GruposAcessosTypes.SEARCH_GRUPOS_ACESSOS, searchGruposAcessos),
    takeLatest(
      GruposAcessosTypes.GET_LIST_GRUPOS_ACESSOS_SELECTS,
      getListGruposAcessosSelects
    ),
    takeLatest(
      GruposAcessosTypes.DELETE_ALL_GRUPOS_ACESSOS,
      deleteAllGruposAcessos
    ),
    takeLatest(FeriadosTypes.GET_LIST_FERIADOS, getListFeriados),
    takeLatest(FeriadosTypes.GET_FERIADOS, getFeriados),
    takeLatest(FeriadosTypes.EDIT_FERIADOS, editFeriados),
    takeLatest(FeriadosTypes.ADD_FERIADOS, addFeriados),
    takeLatest(FeriadosTypes.DELETE_FERIADOS, deleteFeriados),
    takeLatest(FeriadosTypes.SEARCH_FERIADOS, searchFeriados),
    takeLatest(FeriadosTypes.GET_LIST_FERIADOS_SELECTS, getListFeriadosSelects),
    takeLatest(FeriadosTypes.DELETE_ALL_FERIADOS, deleteAllFeriados),
    takeLatest(ClientesTypes.GET_LIST_CLIENTES, getListClientes),
    takeLatest(ClientesTypes.GET_CLIENTES, getClientes),
    takeLatest(ClientesTypes.GET_CLIENTES_DOCS, getClientesDocs),
    takeLatest(ClientesTypes.EDIT_CLIENTES, editClientes),
    takeLatest(ClientesTypes.ADD_CLIENTES, addClientes),
    takeLatest(ClientesTypes.DELETE_CLIENTES, deleteClientes),
    takeLatest(ClientesTypes.SEARCH_CLIENTES, searchClientes),
    takeLatest(ClientesTypes.GET_LIST_CLIENTES_SELECTS, getListClientesSelects),
    takeLatest(ClientesTypes.DELETE_ALL_CLIENTES, deleteAllClientes),
    takeLatest(PropostasTypes.GET_LIST_PROPOSTAS, getListPropostas),
    takeLatest(PropostasTypes.GET_TOTALS_PROPOSTAS, getTotalsPropostas),
    takeLatest(PropostasTypes.GET_PROPOSTAS, getPropostas),
    takeLatest(PropostasTypes.GET_PROPOSTA_HISTORY, getPropostaHistory),
    takeLatest(PropostasTypes.GET_PROPOSTAS_RELATORIO, getPropostasRelatorio),
    takeLatest(PropostasTypes.GET_DOCS_PROPOSTAS, getDocsPropostas),
    takeLatest(PropostasTypes.EDIT_PROPOSTAS, editPropostas),
    takeLatest(PropostasTypes.ADD_PROPOSTAS, addPropostas),
    takeLatest(PropostasTypes.DELETE_PROPOSTAS, deletePropostas),
    takeLatest(PropostasTypes.SEARCH_PROPOSTAS, searchPropostas),
    takeLatest(
      PropostasTypes.GET_LIST_PROPOSTAS_SELECTS,
      getListPropostasSelects
    ),
    takeLatest(PropostasTypes.DELETE_ALL_PROPOSTAS, deleteAllPropostas),
    takeLatest(PropostasTypes.RATE_PROPOSTAS, ratePropostas),
    takeLatest(PropostasTypes.PRINT, print),
    takeLatest(PropostasTypes.CHECK_COLUMN, checkColumn),
    takeLatest(DesempenhoTypes.GET_LIST_DESEMPENHO, getListDesempenho),
    takeLatest(RankingsTypes.GET_LIST_RANKINGS, getListRankings),
    takeLatest(
      PropostasAlertasTypes.GET_LIST_PROPOSTAS_ALERTAS,
      getListPropostasAlertas
    ),
    takeLatest(
      PropostasAlertasTypes.GET_PROPOSTAS_ALERTAS,
      getPropostasAlertas
    ),
    takeLatest(
      PropostasAlertasTypes.GET_PROPOSTAS_ALERTAS_COUNT,
      getPropostasAlertasCount
    ),
    takeLatest(PropostasAlertasTypes.PRINT_ALERTAS, printAlertas),
    takeLatest(
      PropostasAlertasTypes.DELETE_PROPOSTAS_ALERTAS,
      deletePropostasAlertas
    ),
    takeLatest(BorderosTypes.GET_LIST_BORDEROS, getListBorderos),
    takeLatest(BorderosTypes.GET_BORDEROS, getBorderos),
    takeLatest(BorderosTypes.EDIT_BORDEROS, editBorderos),
    takeLatest(BorderosTypes.ADD_BORDEROS, addBorderos),
    takeLatest(BorderosTypes.DELETE_BORDEROS, deleteBorderos),
    takeLatest(BorderosTypes.SEARCH_BORDEROS, searchBorderos),
    takeLatest(BorderosTypes.GET_LIST_BORDEROS_SELECTS, getListBorderosSelects),
    takeLatest(BorderosTypes.PRINT, printBordero),
    takeLatest(
      BorderosTypes.GET_DOCS_PROPOSTAS_BORDERO,
      getDocsPropostasBordero
    ),
    takeLatest(BorderosTypes.DELETE_ALL_BORDEROS, deleteAllBorderos),
    takeLatest(ExtratoPagoTypes.GET_LIST_EXTRATO_PAGO, getListExtratoPago),
    takeLatest(ExtratoPagoTypes.GET_EXTRATO_PAGO, getExtratoPago),
    takeLatest(ExtratoPagoTypes.DELETE_EXTRATO_PAGO, deleteExtratoPago),
    takeLatest(
      GerarRepassesTypes.GET_LIST_GERAR_REPASSES,
      getListGerarRepasses
    ),
    takeLatest(GerarRepassesTypes.GET_GERAR_REPASSES, getGerarRepasses),
    takeLatest(EmpresaTypes.GET_EMPRESA, getEmpresa),
    takeLatest(EmpresaTypes.EDIT_EMPRESA, editEmpresa),
    takeLatest(MetasTypes.GET_LIST_METAS, getListMetas),
    takeLatest(MetasTypes.GET_METAS, getMetas),
    takeLatest(MetasTypes.EDIT_METAS, editMetas),
    takeLatest(MetasTypes.ADD_METAS, addMetas),
    takeLatest(MetasTypes.ADD_METAS_METAS, addMetasMetas),
    takeLatest(MetasTypes.DELETE_METAS, deleteMetas),
    takeLatest(MetasTypes.SEARCH_METAS, searchMetas),
    takeLatest(MetasTypes.GET_LIST_METAS_SELECTS, getListMetasSelects),
    takeLatest(
      RelatorioMetasTypes.GET_LIST_RELATORIO_METAS,
      getListMetasRelatorio
    ),
    takeLatest(ComunicadosTypes.GET_LIST_COMUNICADOS, getListComunicados),
    takeLatest(ComunicadosTypes.GET_COMUNICADOS, getComunicados),
    takeLatest(ComunicadosTypes.EDIT_COMUNICADOS, editComunicados),
    takeLatest(ComunicadosTypes.ADD_COMUNICADOS, addComunicados),
    takeLatest(ComunicadosTypes.DELETE_COMUNICADOS, deleteComunicados),
    takeLatest(ComunicadosTypes.SEARCH_COMUNICADOS, searchComunicados),
    takeLatest(
      ComunicadosTypes.GET_LIST_COMUNICADOS_SELECTS,
      getListComunicadosSelects
    ),
    takeLatest(ComunicadosTypes.DELETE_ALL_COMUNICADOS, deleteAllComunicados),
    takeLatest(PermissionsTypes.GET_FULL_COMUNICADOS, getFullComunicados),
    takeLatest(
      StatusAtendimentoTypes.GET_LIST_STATUS_ATENDIMENTO,
      getListStatusAtendimento
    ),
    takeLatest(
      StatusAtendimentoTypes.GET_STATUS_ATENDIMENTO,
      getStatusAtendimento
    ),
    takeLatest(
      StatusAtendimentoTypes.EDIT_STATUS_ATENDIMENTO,
      editStatusAtendimento
    ),
    takeLatest(
      StatusAtendimentoTypes.ADD_STATUS_ATENDIMENTO,
      addStatusAtendimento
    ),
    takeLatest(
      StatusAtendimentoTypes.DELETE_STATUS_ATENDIMENTO,
      deleteStatusAtendimento
    ),
    takeLatest(
      StatusAtendimentoTypes.SEARCH_STATUS_ATENDIMENTO,
      searchStatusAtendimento
    ),
    takeLatest(
      StatusAtendimentoTypes.GET_LIST_STATUS_ATENDIMENTO_SELECTS,
      getListStatusAtendimentoSelects
    ),
    takeLatest(
      StatusAtendimentoTypes.DELETE_ALL_STATUS_ATENDIMENTO,
      deleteAllStatusAtendimento
    ),
    takeLatest(
      FormasAtendimentoTypes.GET_LIST_FORMAS_ATENDIMENTO,
      getListFormasAtendimento
    ),
    takeLatest(
      FormasAtendimentoTypes.GET_FORMAS_ATENDIMENTO,
      getFormasAtendimento
    ),
    takeLatest(
      FormasAtendimentoTypes.EDIT_FORMAS_ATENDIMENTO,
      editFormasAtendimento
    ),
    takeLatest(
      FormasAtendimentoTypes.ADD_FORMAS_ATENDIMENTO,
      addFormasAtendimento
    ),
    takeLatest(
      FormasAtendimentoTypes.DELETE_FORMAS_ATENDIMENTO,
      deleteFormasAtendimento
    ),
    takeLatest(
      FormasAtendimentoTypes.SEARCH_FORMAS_ATENDIMENTO,
      searchFormasAtendimento
    ),
    takeLatest(
      FormasAtendimentoTypes.GET_LIST_FORMAS_ATENDIMENTO_SELECTS,
      getListFormasAtendimentoSelects
    ),
    takeLatest(
      FormasAtendimentoTypes.DELETE_ALL_FORMAS_ATENDIMENTO,
      deleteAllFormasAtendimento
    ),
    takeLatest(BuscaClienteTypes.BUSCA_CLIENTE_ACTION, buscaClienteAction),
    takeLatest(BuscaClienteTypes.SORTEIA_CLIENTE, sorteiaCliente),
    takeLatest(AtendimentoTypes.GET_ATENDIMENTO, getAtendimento),
    takeLatest(AtendimentoTypes.INICIA_ATENDIMENTO, iniciaAtendimento),
    takeLatest(AtendimentoTypes.FINALIZA_ATENDIMENTO, finalizaAtendimento),
    takeLatest(
      RelatorioAtendimentoTypes.GET_LIST_RELATORIO_ATENDIMENTO,
      getListRelatorioAtendimento
    ),
    takeLatest(CampanhasTypes.GET_LIST_CAMPANHAS, getListCampanhas),
    takeLatest(CampanhasTypes.GET_CAMPANHAS, getCampanhas),
    takeLatest(CampanhasTypes.EDIT_CAMPANHAS, editCampanhas),
    takeLatest(CampanhasTypes.ADD_CAMPANHAS, addCampanhas),
    takeLatest(CampanhasTypes.DELETE_CAMPANHAS, deleteCampanhas),
    takeLatest(CampanhasTypes.SEARCH_CAMPANHAS, searchCampanhas),
    takeLatest(CampanhasTypes.DELETE_ALL_CAMPANHAS, deleteAllCampanhas),
    takeLatest(ConsignadoInssTypes.SEARCH_CPF, searchCPF),
    takeLatest(ConsignadoInssTypes.SEARCH_NB, searchNB),
    takeLatest(DadosCadastraisTypes.SEARCH_DADOS, searchDados),
    takeLatest(DadosCadastraisTypes.SEARCH_DADOS_TAB, searchDadosTab),
    takeLatest(DadosCadastraisTypes.SEARCH_DADOS_CNPJ_TAB, searchDadosCnpjTab),
    takeLatest(
      DadosCadastraisTypes.SEARCH_DADOS_RELACIONADAS_TAB,
      searchDadosRelacionadasTab
    ),
    takeLatest(AgendamentosTypes.GET_AGENDAMENTOS, getAgendamentos),
    takeLatest(AgendamentosTypes.ADD_AGENDAMENTOS, addAgendamentos),
    takeLatest(AgendamentosTypes.GET_AGENDAMENTO, getAgendamento),
    takeLatest(AgendamentosTypes.EDIT_AGENDAMENTOS, editAgendamentos),
    takeLatest(AgendamentosTypes.EXCLUIR_AGENDAMENTOS, excluirAgendamentos),
    takeLatest(OrganogramaTypes.GET_ORGANOGRAMA, getOrganograma),
    takeLatest(
      TiposCompromissosTypes.GET_LIST_TIPOS_COMPROMISSOS,
      getListTiposCompromissos
    ),
    takeLatest(
      TiposCompromissosTypes.GET_TIPOS_COMPROMISSOS,
      getTiposCompromissos
    ),
    takeLatest(
      TiposCompromissosTypes.EDIT_TIPOS_COMPROMISSOS,
      editTiposCompromissos
    ),
    takeLatest(
      TiposCompromissosTypes.ADD_TIPOS_COMPROMISSOS,
      addTiposCompromissos
    ),
    takeLatest(
      TiposCompromissosTypes.DELETE_TIPOS_COMPROMISSOS,
      deleteTiposCompromissos
    ),
    takeLatest(
      TiposCompromissosTypes.SEARCH_TIPOS_COMPROMISSOS,
      searchTiposCompromissos
    ),
    takeLatest(
      TiposCompromissosTypes.GET_LIST_TIPOS_COMPROMISSOS_SELECTS,
      getListTiposCompromissosSelects
    ),
    takeLatest(
      CalendarioPesquisadorTypes.GET_CALENDARIO_PESQUISADOR,
      getCalendarioPesquisador
    ),
    takeLatest(
      CategoriasPagamentosTypes.GET_LIST_CATEGORIAS_PAGAMENTOS,
      getListCategoriasPagamentos
    ),
    takeLatest(
      CategoriasPagamentosTypes.GET_CATEGORIAS_PAGAMENTOS,
      getCategoriasPagamentos
    ),
    takeLatest(
      CategoriasPagamentosTypes.EDIT_CATEGORIAS_PAGAMENTOS,
      editCategoriasPagamentos
    ),
    takeLatest(
      CategoriasPagamentosTypes.ADD_CATEGORIAS_PAGAMENTOS,
      addCategoriasPagamentos
    ),
    takeLatest(
      CategoriasPagamentosTypes.DELETE_CATEGORIAS_PAGAMENTOS,
      deleteCategoriasPagamentos
    ),
    takeLatest(
      CategoriasPagamentosTypes.SEARCH_CATEGORIAS_PAGAMENTOS,
      searchCategoriasPagamentos
    ),
    takeLatest(
      CategoriasPagamentosTypes.GET_LIST_CATEGORIAS_PAGAMENTOS_SELECTS,
      getListCategoriasPagamentosSelects
    ),
    takeLatest(
      CategoriasPagamentosTypes.DELETE_ALL_CATEGORIAS_PAGAMENTOS,
      deleteAllCategoriasPagamentos
    ),
    takeLatest(
      CategoriasRecebimentosTypes.GET_LIST_CATEGORIAS_RECEBIMENTOS,
      getListCategoriasRecebimentos
    ),
    takeLatest(
      CategoriasRecebimentosTypes.GET_CATEGORIAS_RECEBIMENTOS,
      getCategoriasRecebimentos
    ),
    takeLatest(
      CategoriasRecebimentosTypes.EDIT_CATEGORIAS_RECEBIMENTOS,
      editCategoriasRecebimentos
    ),
    takeLatest(
      CategoriasRecebimentosTypes.ADD_CATEGORIAS_RECEBIMENTOS,
      addCategoriasRecebimentos
    ),
    takeLatest(
      CategoriasRecebimentosTypes.DELETE_CATEGORIAS_RECEBIMENTOS,
      deleteCategoriasRecebimentos
    ),
    takeLatest(
      CategoriasRecebimentosTypes.SEARCH_CATEGORIAS_RECEBIMENTOS,
      searchCategoriasRecebimentos
    ),
    takeLatest(
      CategoriasRecebimentosTypes.GET_LIST_CATEGORIAS_RECEBIMENTOS_SELECTS,
      getListCategoriasRecebimentosSelects
    ),
    takeLatest(
      CategoriasRecebimentosTypes.DELETE_ALL_CATEGORIAS_RECEBIMENTOS,
      deleteAllCategoriasRecebimentos
    ),
    takeLatest(
      MetodosPagamentosTypes.GET_LIST_METODOS_PAGAMENTOS,
      getListMetodosPagamentos
    ),
    takeLatest(
      MetodosPagamentosTypes.GET_METODOS_PAGAMENTOS,
      getMetodosPagamentos
    ),
    takeLatest(
      MetodosPagamentosTypes.EDIT_METODOS_PAGAMENTOS,
      editMetodosPagamentos
    ),
    takeLatest(
      MetodosPagamentosTypes.ADD_METODOS_PAGAMENTOS,
      addMetodosPagamentos
    ),
    takeLatest(
      MetodosPagamentosTypes.DELETE_METODOS_PAGAMENTOS,
      deleteMetodosPagamentos
    ),
    takeLatest(
      MetodosPagamentosTypes.SEARCH_METODOS_PAGAMENTOS,
      searchMetodosPagamentos
    ),
    takeLatest(
      MetodosPagamentosTypes.GET_LIST_METODOS_PAGAMENTOS_SELECTS,
      getListMetodosPagamentosSelects
    ),
    takeLatest(
      MetodosPagamentosTypes.DELETE_ALL_METODOS_PAGAMENTOS,
      deleteAllMetodosPagamentos
    ),
    takeLatest(LancamentosTypes.GET_LIST_LANCAMENTOS, getListLancamentos),
    takeLatest(LancamentosTypes.GET_LANCAMENTOS, getLancamentos),
    takeLatest(LancamentosTypes.GET_EXPORT, getExport),
    takeLatest(LancamentosTypes.EDIT_LANCAMENTOS, editLancamentos),
    takeLatest(LancamentosTypes.ADD_LANCAMENTOS, addLancamentos),
    takeLatest(LancamentosTypes.DELETE_LANCAMENTOS, deleteLancamentos),
    takeLatest(
      LancamentosTypes.DELETE_LANCAMENTOS_PARCELA,
      deleteLancamentosParcela
    ),
    takeLatest(LancamentosTypes.SEARCH_LANCAMENTOS, searchLancamentos),
    takeLatest(
      LancamentosTypes.GET_LIST_LANCAMENTOS_SELECTS,
      getListLancamentosSelects
    ),
    takeLatest(LancamentosTypes.DELETE_ALL_LANCAMENTOS, deleteAllLancamentos),
    takeLatest(
      GruposRepassesTypes.GET_LIST_GRUPOS_REPASSES,
      getListGruposRepasses
    ),
    takeLatest(GruposRepassesTypes.GET_GRUPOS_REPASSES, getGruposRepasses),
    takeLatest(GruposRepassesTypes.EDIT_GRUPOS_REPASSES, editGruposRepasses),
    takeLatest(GruposRepassesTypes.ADD_GRUPOS_REPASSES, addGruposRepasses),
    takeLatest(
      GruposRepassesTypes.DELETE_GRUPOS_REPASSES,
      deleteGruposRepasses
    ),
    takeLatest(
      GruposRepassesTypes.SEARCH_GRUPOS_REPASSES,
      searchGruposRepasses
    ),
    takeLatest(
      GruposRepassesTypes.GET_LIST_GRUPOS_REPASSES_SELECTS,
      getListGruposRepassesSelects
    ),
    takeLatest(
      GruposRepassesTypes.DELETE_ALL_GRUPOS_REPASSES,
      deleteAllGruposRepasses
    ),
    takeLatest(ExtratoTypes.GET_LIST_EXTRATO, getListExtrato),
    takeLatest(
      ContasBancariasTypes.GET_LIST_CONTAS_BANCARIAS,
      getListContasBancarias
    ),
    takeLatest(ContasBancariasTypes.GET_CONTAS_BANCARIAS, getContasBancarias),
    takeLatest(ContasBancariasTypes.EDIT_CONTAS_BANCARIAS, editContasBancarias),
    takeLatest(ContasBancariasTypes.ADD_CONTAS_BANCARIAS, addContasBancarias),
    takeLatest(
      ContasBancariasTypes.DELETE_CONTAS_BANCARIAS,
      deleteContasBancarias
    ),
    takeLatest(
      ContasBancariasTypes.SEARCH_CONTAS_BANCARIAS,
      searchContasBancarias
    ),
    takeLatest(
      ContasBancariasTypes.GET_LIST_CONTAS_BANCARIAS_SELECTS,
      getListContasBancariasSelects
    ),
    takeLatest(
      ContasBancariasTypes.DELETE_ALL_CONTAS_BANCARIAS,
      deleteAllContasBancarias
    ),
    takeLatest(CoeficientesTypes.GET_LIST_COEFICIENTES, getListCoeficientes),
    takeLatest(CoeficientesTypes.GET_COEFICIENTES, getCoeficientes),
    takeLatest(CoeficientesTypes.EDIT_COEFICIENTES, editCoeficientes),
    takeLatest(CoeficientesTypes.ADD_COEFICIENTES, addCoeficientes),
    takeLatest(CoeficientesTypes.DELETE_COEFICIENTES, deleteCoeficientes),
    takeLatest(CoeficientesTypes.SEARCH_COEFICIENTES, searchCoeficientes),
    takeLatest(
      CoeficientesTypes.GET_LIST_COEFICIENTES_SELECTS,
      getListCoeficientesSelects
    ),
    takeLatest(
      CoeficientesTypes.DELETE_ALL_COEFICIENTES,
      deleteAllCoeficientes
    ),
    takeLatest(FiltrosValoresDiariosTypes.GET_VALUES, getValues),
    takeLatest(
      FiltrosValoresDiariosTypes.GET_PROPOSTAS_DIARIOS,
      getPropostasDiarios
    ),
    takeLatest(
      FiltrosCalendarioUsoPesquisadorTypes.GET_VALUES_PESQUISADOR,
      getValuesPesquisador
    ),
    takeLatest(ImportacoesTypes.GET_LIST_IMPORTACOES, getListImportacoes),
    takeLatest(ImportacoesTypes.GET_IMPORTACOES, getImportacoes),
    takeLatest(ImportacoesTypes.EDIT_IMPORTACOES, editImportacoes),
    takeLatest(ImportacoesTypes.ADD_IMPORTACOES, addImportacoes),
    takeLatest(ImportacoesTypes.DELETE_IMPORTACOES, deleteImportacoes),
    takeLatest(ImportacoesTypes.SEARCH_IMPORTACOES, searchImportacoes),
    takeLatest(
      ImportacoesTypes.GET_LIST_IMPORTACOES_SELECTS,
      getListImportacoesSelects
    ),
    takeLatest(ImportacoesTypes.DELETE_ALL_IMPORTACOES, deleteAllImportacoes),
    takeLatest(
      CategoriasBonusDescontoTypes.GET_LIST_CATEGORIAS_BONUS_DESCONTO,
      getListCategoriasBonusDesconto
    ),
    takeLatest(
      CategoriasBonusDescontoTypes.GET_CATEGORIAS_BONUS_DESCONTO,
      getCategoriasBonusDesconto
    ),
    takeLatest(
      CategoriasBonusDescontoTypes.EDIT_CATEGORIAS_BONUS_DESCONTO,
      editCategoriasBonusDesconto
    ),
    takeLatest(
      CategoriasBonusDescontoTypes.ADD_CATEGORIAS_BONUS_DESCONTO,
      addCategoriasBonusDesconto
    ),
    takeLatest(
      CategoriasBonusDescontoTypes.DELETE_CATEGORIAS_BONUS_DESCONTO,
      deleteCategoriasBonusDesconto
    ),
    takeLatest(
      CategoriasBonusDescontoTypes.SEARCH_CATEGORIAS_BONUS_DESCONTO,
      searchCategoriasBonusDesconto
    ),
    takeLatest(
      CategoriasBonusDescontoTypes.GET_LIST_CATEGORIAS_BONUS_DESCONTO_SELECTS,
      getListCategoriasBonusDescontoSelects
    ),
    takeLatest(
      CategoriasBonusDescontoTypes.DELETE_ALL_CATEGORIAS_BONUS_DESCONTO,
      deleteAllCategoriasBonusDesconto
    ),
    takeLatest(
      BonusDescontoTypes.GET_LIST_BONUS_DESCONTO,
      getListBonusDesconto
    ),
    takeLatest(BonusDescontoTypes.GET_BONUS_DESCONTO, getBonusDesconto),
    takeLatest(BonusDescontoTypes.EDIT_BONUS_DESCONTO, editBonusDesconto),
    takeLatest(BonusDescontoTypes.ADD_BONUS_DESCONTO, addBonusDesconto),
    takeLatest(BonusDescontoTypes.DELETE_BONUS_DESCONTO, deleteBonusDesconto),
    takeLatest(
      BonusDescontoTypes.DELETE_BONUS_DESCONTO_PARCELA,
      deleteBonusDescontoParcela
    ),
    takeLatest(BonusDescontoTypes.SEARCH_BONUS_DESCONTO, searchBonusDesconto),
    takeLatest(
      BonusDescontoTypes.GET_LIST_BONUS_DESCONTO_SELECTS,
      getListBonusDescontoSelects
    ),
    takeLatest(
      BonusDescontoTypes.DELETE_ALL_BONUS_DESCONTO,
      deleteAllBonusDesconto
    ),
  ]);
}



// WEBPACK FOOTER //
// ./src/store/sagas/index.js